export default class Resource {

    constructor(data) {
        this.id = null;
        this.name = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/resource.model.js